function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import awaitCondition from '../utils/awaitCondition';

var BranchSDK = function BranchSDK(props) {
  var branchKey = props.branchKey,
      onError = props.onError,
      onInitSuccess = props.onInitSuccess,
      options = props.options;

  var branch_match_id = options.branchMatchId,
      branch_view_id = options.branchViewId,
      no_journeys = options.noJourneys,
      disable_entry_animation = options.disableEntryAnimation,
      disable_exit_animation = options.disableExitAnimation,
      retry_delay = options.retryDelay,
      _options$trackingDisa = options.trackingDisabled,
      tracking_disabled = _options$trackingDisa === void 0 ? true : _options$trackingDisa,
      remainingOptions = _objectWithoutProperties(options, ["branchMatchId", "branchViewId", "noJourneys", "disableEntryAnimation", "disableExitAnimation", "retryDelay", "trackingDisabled"]);

  var mappedOptions = _objectSpread({
    branch_match_id: branch_match_id,
    branch_view_id: branch_view_id,
    no_journeys: no_journeys,
    disable_entry_animation: disable_entry_animation,
    disable_exit_animation: disable_exit_animation,
    retry_delay: retry_delay,
    tracking_disabled: tracking_disabled
  }, remainingOptions);

  var html = "// load Branch\n  (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src=\"https://cdn.branch.io/branch-latest.min.js\";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,\"script\",\"branch\",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},\"addListener banner closeBanner closeJourney data deepview deepviewCta first init link logout removeListener setBranchViewData setIdentity track trackCommerceEvent logEvent disableTracking getBrowserFingerprintId crossPlatformIds lastAttributedTouchData setAPIResponseCallback qrCode\".split(\" \"), 0);\n  ";
  useEffect(function () {
    if (window) {
      awaitCondition(function () {
        return !!window.branch;
      }).then(function () {
        window.branch.init(branchKey, mappedOptions, function (err, data) {
          if (err) {
            onError(err);
          } else {
            onInitSuccess(data);
          }
        }); // Currently awaitCondition.catch() doesn't return 'err' but it will be updated
      }).catch(onError);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("script", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: html
    },
    type: "text/javascript"
  }));
};

BranchSDK.defaultProps = {
  onError: function onError() {},
  onInitSuccess: function onInitSuccess() {},
  options: {
    trackingDisabled: true
  }
};
BranchSDK.propTypes = {
  /**
   * Key that client passes in for initialization depending on environment line
   */
  branchKey: PropTypes.string.isRequired,

  /**
   * event callback to be called when Branch fails to initialize
   */
  onError: PropTypes.func,

  /**
   * event callback to be called when Branch initializes successfully
   */
  onInitSuccess: PropTypes.func,

  /**
   * Object that allows client to initialize Branch with special options
   * Docs: https://help.branch.io/developers-hub/docs/web-full-reference#options-data-object
   */
  options: PropTypes.shape({
    /**
     * The current user's browser-fingerprint-id
     */
    branchMatchId: PropTypes.string,

    /**
     * To test how Journeys render on your page before activation, set this parameter
     */
    branchViewId: PropTypes.string,

    /**
     * When true, prevents Journeys from appearing on current page
     */
    noJourneys: PropTypes.bool,

    /**
     * When true, prevents a Journeys entry animation
     */
    disableEntryAnimation: PropTypes.bool,

    /**
     * When true, prevents a Journeys exit animation
     */
    disableExitAnimation: PropTypes.bool,

    /**
     * Value specifying the number of times a Branch API call can be retried
     */
    retries: PropTypes.number,

    /**
     * Time in ms to wait before retrying a timed-out request to the Branch API
     */
    retryDelay: PropTypes.number,

    /**
     * Duration in ms that the system should wait for a response before considering Branch timed out
     */
    timeout: PropTypes.number,

    /**
     * Key-value pairs used to target Journeys users
     */
    metadata: PropTypes.object,

    /**
     * Value added to branch-journey-cta script. Used to allow script from a Content Security Policy
     */
    nonce: PropTypes.string,

    /**
     * Setting to true disables tracking
     */
    trackingDisabled: PropTypes.bool
  })
};
export default BranchSDK;